import {AccessCodeAlphabet, Platform} from "@variocube/app-api";
import {EventSupportingApp, getRandomElement, occupyAndConfirm} from "@variocube/app-common";
import {AppContext, createTheme} from "@variocube/cube-ui";
import * as React from "react";
import {render} from "react-dom";
import icon from "./delivery.svg";
import {App} from "./app";
import {Category, Product, Shop, TaxedSumWrapper} from "./types";
import {LocalizationProvider, SUPPORTED_LANGUAGES} from "../i18n";

export default class extends EventSupportingApp {

    constructor(p: Platform) {
        super(p, icon, "#9d0aa2", SUPPORTED_LANGUAGES);
    }

    render(root: Element) {
        const appContext = {
            platform: this.platform,
            appEventSupport: this.eventSupport
        };
        render((
            <AppContext.Provider value={appContext}>
                <LocalizationProvider app={this}>
                    <div className={rentalTheme}>
                        <App/>
                    </div>
                </LocalizationProvider>
            </AppContext.Provider>
        ), root);
    }

    async loadMockData() {
        const categories: Category[] = [
            {
                id: "drinks",
                name: "Getränke",
                image: "https://files.billa.at/files/artikel/00-699888_01__1200x1200.jpg"
            },
            {
                id: "snacks",
                name: "Snacks",
                image: "https://files.billa.at/files/artikel/00-601779_01__1200x1200.jpg"
            },
            {
                id: "sides",
                name: "Beilagen",
                image: "https://files.billa.at/files/artikel/00-294693_01__1200x1200.jpg"
            },
            {
                id: "leichtgas",
                name: "Leichtgas",
                image: "https://variocube-documents.s3.eu-west-1.amazonaws.com/variocube.vending/dopgas/leichtflasche-10kg.jpg"
            }
        ];
        const products: Product[] = [
            {
                id: "65d5981b-2733-45c1-a723-ac6a799a96c3",
                name: "Apfelsaft",
                image: "https://files.billa.at/files/artikel/00-699888_01__1200x1200.jpg",
                description: "BILLA Apfesaft Naturtrüb",
                category: "drinks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "2b1c1a2b-e592-4a02-9dfe-c977c205fc8e",
                name: "Orangensaft",
                image: "https://files.billa.at/files/artikel/00-381398_01__1200x1200.jpg",
                description: "Der Hersteller SanLucar fängt in seinem Orangensaft das intensive Aroma frischer Orangen ein. Die schonende Herstellung garantiert einen hohen Vitamingehalt.",
                category: "drinks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "27c1eee7-cdb5-45f4-902a-a441dea04f40",
                name: "Pago Erdbeere",
                image: "https://files.billa.at/files/artikel/00-902329_01__1200x1200.jpg",
                description: "Pago Erdbeer ist ein natürlich-fruchtiges Getränk aus Österreich, angereichert mit köstlichem Erdbeermark, Zitrone, Aronia und Holunderbeere.",
                category: "drinks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "48b37806-312a-4eba-8652-45fe5a267051",
                name: "Steam Beer",
                image: "https://files.billa.at/files/artikel/00-322039_01__1200x1200.jpg",
                description: "Ein Lager mit Tradition: Die Rezeptur für das leuchtend bernsteinfarbene Steam Beer der kalifornischen Brauerei Anchor gibt es schon seit 1896.",
                category: "drinks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "380e6453-008d-46d0-80f1-64757bb35870",
                name: "Red Bull Cola",
                image: "https://files.billa.at/files/artikel/00-617703_01__1200x1200.jpg",
                description: "ORGANICS by Red Bull SIMPLY COLA: Mit edler Würze und feiner Süße. Der einzigartige Mix aus ausgewählten Pflanzenextrakten, natürlichem Koffein und Bio-Zitronensaftkonzentrat.",
                category: "drinks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "fc96e0ab-af4d-4cd9-9f03-9f460d154e22",
                name: "Mars",
                image: "https://files.billa.at/files/artikel/00-601779_01__1200x1200.jpg",
                description: "BILLA Apfesaft Naturtrüb",
                category: "snacks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "0b3d14c6-a13f-425d-a5bd-dfe1d5ef793b",
                name: "Twix Sticks 10er",
                image: "https://files.billa.at/files/artikel/00-957770_01__1200x1200.jpg",
                description: "Die einzeln verpackten Twix Sticks sind köstliche Schokoriegel aus Knusperkeks, Karamell und Schokolade. Die kleinen Riegel passen in nahezu jede Tasche.",
                category: "snacks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "d03b4ad8-eb1a-44d1-9c99-1cce83d0a1be",
                name: "Apfelringe",
                image: "https://files.billa.at/files/artikel/00-642238_01__1200x1200.jpg",
                description: "Apfelringe ohne Schale: Für diese Spezialität werden österreichische Tafeläpfel traditionell im warmen Luftstrom gedörrt. Apfelringe sind ein gesunder Snack für unterwegs.",
                category: "snacks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "6870c684-1f9b-4db9-8746-de16334cf352",
                name: "Snickers 10er",
                image: "https://files.billa.at/files/artikel/00-368152_01__1200x1200.jpg",
                description: "Für die Stärkung zwischendurch: Die kleinen Snickers Sticks überzeugen mit dem gewohnt kräftigen Karamell-Geschmack, zarter Candy-Creme und gerösteter Erdnuss.",
                category: "snacks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "43706e4d-0717-4200-a8f9-ab24d3eba65e",
                name: "Nic Nac's",
                image: "https://files.billa.at/files/artikel/00-450003_01__1200x1200.jpg",
                description: "Lorenz Nic Nac's Wasabi von Lorenz 110 Gramm Packung",
                category: "snacks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "08829d6e-c714-46a5-8a6f-5e9053aab0e5",
                name: "Pikante Mandeln",
                image: "https://files.billa.at/files/artikel/00-776265_01__1200x1200.jpg",
                description: "Die pikanten Mandeln von BILLA in der kleinen Packung eignen sich hervorragend als kleiner Imbiss unterwegs oder als gesunder Knabberspaß am Abend.",
                category: "snacks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "b44f7415-b713-4727-8d9f-de69d0a6930b",
                name: "Studentenfutter",
                image: "https://files.billa.at/files/artikel/00-342818_01__1200x1200.jpg",
                description: "Das Studentenfutter von Seeberger ist ein reichhaltiger Snack für zwischendurch. Die gesunde Nuss- und Rosinenmischung lässt sich auch gut im Müsli einsetzen.",
                category: "snacks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "17f945ba-018d-44f7-ab9d-45fc2faf766d",
                name: "Kelly's Snips",
                image: "https://files.billa.at/files/artikel/00-657771_01__1200x1200.jpg",
                description: "Die Giant Snips von Kelly's sind beeindruckend große Erdnussflips. Mit ihrer einzigartigen Rezeptur sind sie noch größer und enthalten noch mehr Erdnüsse.",
                category: "snacks",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "ddb81287-27e9-4532-83e6-fdeec13be324",
                name: "Ketchup",
                image: "https://files.billa.at/files/artikel/00-294693_01__1200x1200.jpg",
                description: "BILLA Apfesaft Naturtrüb",
                category: "sides",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "9de7d2d8-1516-489b-9b38-70613c63af22",
                name: "Grillsenf",
                image: "https://files.billa.at/files/artikel/00-57624_01__1200x1200.jpg",
                description: "Der pikant-würzige Geschmack von Haas Grillsenf rundet Herzhaftes vom Grill wie Würstel, Fleischlaibchen und Steaks aromatisch ab.",
                category: "sides",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "a874512a-4f65-4832-b54d-ea51392e1c5a",
                name: "Tabasco",
                image: "https://files.billa.at/files/artikel/00-785276_01__1200x1200.jpg",
                description: "Grüne Tabascosauce ist nicht zu scharf und nicht zu mild. Die aus Jalapeños gewonnene Soße lässt sich gut zu Gegrilltem kombinieren.",
                category: "sides",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "79695dcf-dc04-4c53-a402-0f36702d2633",
                name: "Händlmaier",
                image: "https://files.billa.at/files/artikel/00-837030_01__1200x1200.jpg",
                description: "Händlmaier Altbayrischer Senf im Glas schmeckt süßlich-pikant und enthält erlesene Zutaten wie braunen Zucker und Tafelmeerrettich.",
                category: "sides",
                price: TaxedSumWrapper.random().taxedSum
            },
            {
                id: "f739176c-5365-41b5-9046-0ddbf811e8be",
                name: "Leichtgas 10kg",
                image: "https://variocube-documents.s3.eu-west-1.amazonaws.com/variocube.vending/dopgas/leichtflasche-10kg.jpg",
                description: "Kunststofflasche 10 kg,\n" +
                    "Gesamthöhe: 58 cm,\n" +
                    "Durchmesser: 30,5 cm,\n" +
                    "Füllgewicht: 10 kg Propan,\n" +
                    "Leergewicht: 6,7 kg,\n" +
                    "Gasentnahme: gasförmig",
                category: "leichtgas",
                price: TaxedSumWrapper.random().taxedSum
            },
        ];

        try {
            const first = products[0];
            for (let i = 0; i < 3; i++) {
                const occupancy = await occupyAndConfirm(this.platform, {
                    type: getRandomElement(["S", "M", "L"]),
                    accessCodeShape: {
                        length: 5,
                        alphabet: AccessCodeAlphabet.OneToNine,
                    },
                    content: {
                        product: first.id
                    },
                });
                console.info("Created occupancy for product", occupancy);
            }
        } catch (error) {
            // ignore error when no more occupancy can be made
        }

        return {
            shop: {
                accessCode: "12345",
            },
            categories,
            products
        } as MockData;
    }
}

interface MockData {
    shop: Shop;
    categories: Category[];
    products: Product[];
}


const rentalTheme = createTheme({
    colorBackground: "#f5e4f6",
    colorForeground: "#381c39",
    colorPrimary: "#9d0aa2",
    colorSeparator: "#56646b",
    colorInputBackground: "#fff",
});


